import type { ImportPrizesProps } from './ImportPrizes.types'
import Box from '@mui/material/Box'
import useQueryGet from 'hooks/useQueryGet'
import RequestStatus from 'components/RequestStatus/RequestStatus'
import type { PrizeToImport } from 'types/Prize'
import { useAuthContext } from 'context/AuthContext/AuthContext'

import { PrizeTabs } from './features/prize-tabs'
import { Divider } from '@mui/material'
import { PrizesSummary } from './features/prizes-summary'
import { PrizesSignatures } from './features/prizes-signature'
import { Upload } from './features/upload'
import { Can } from 'config/ability'
import { HistoryLogs } from './features/history-logs'

const colors = ['#175CD3', '#C11574', '#067647']

export const WinnersNotifications = ({ market }: ImportPrizesProps): JSX.Element => {
  const { token } = useAuthContext()

  const {
    data: prizes,
    isLoading: isPrizesLoading,
    refetch,
  } = useQueryGet<PrizeToImport[]>({
    queryKey: ['all-prizes', token, market],
    endpoint: 'prize-draw',
    options: { params: { marketId: market?.id ?? '' } },
  })

  if (prizes === undefined || 'error' in prizes) {
    return <RequestStatus data={prizes} isLoading={isPrizesLoading} />
  }

  return (
    <>
      <Divider sx={{ mb: 2 }} />
      <Box display="flex" alignItems="stretch" flexWrap="wrap" gap={4}>
        <Box flexBasis={320} display="flex" flexDirection="column" gap={4}>
          <PrizeTabs prizes={prizes} colors={colors} />
          <PrizesSummary prizes={prizes} colors={colors} />
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box flex={1} display="flex" flexDirection="column" gap={4}>
          <PrizesSignatures prizes={prizes} />
          {market != null && (
            <Can I="upload" a="Import prizes">
              <Upload
                market={market}
                refetch={() => {
                  void refetch({ exact: false, queryKey: ['all-prizes'] })
                }}
              />
            </Can>
          )}
          {market?.code && <HistoryLogs marketCode={market.code} marketDescription={market?.description} />}
        </Box>
      </Box>
    </>
  )
}
